import { API, DEFAULT_API_VERSION } from './constants';
/**
 * Removes the leading slash from a path string if present.
 *
 * @param path - The path string to process
 * @returns The path without a leading slash
 */
const dropFirstSlash = (path) => path.startsWith('/') ? path.slice(1) : path;
/**
 * Builds a complete API URL by combining the base API endpoint, version, and path.
 *
 * @param endpoint - The API endpoint (e.g., 'api' or '/api')
 * @param path - The resource path (e.g., 'users' or '/users')
 * @param version - The API version (defaults to DEFAULT_API_VERSION)
 * @returns The complete API URL string
 *
 * @example
 * urlBuilder('api', 'users', 'v1/') // Returns: 'https://api.starjack.at/api/v1/users'
 */
export const urlBuilder = (endpoint, path, version = DEFAULT_API_VERSION) => `${API}${dropFirstSlash(endpoint)}/${version}${dropFirstSlash(path)}`;
/**
 * Builds a URL query string from a record of parameters.
 * Filters out null, undefined, and empty array values.
 * Arrays are converted to comma-separated strings.
 *
 * @param params - A record of key-value pairs to convert to query parameters
 * @returns A query string starting with '?' or an empty string if no valid params
 *
 * @example
 * buildSearchParams({ name: 'John', age: 30, tags: ['a', 'b'] })
 * // Returns: '?name=John&age=30&tags=a,b'
 */
export const buildSearchParams = (params) => {
    if (params === null)
        return '';
    let paramString = '?';
    let paramIndex = 0;
    for (const key in params) {
        const param = params[key];
        if (key && param !== null && param !== undefined) {
            if (Array.isArray(param)) {
                const filtered = param.filter((entry) => entry !== null && entry !== undefined);
                if (filtered.length === 0) {
                    continue;
                }
            }
            const paramValue = Array.isArray(param)
                ? param.join(',')
                : String(param);
            paramString = `${paramString}${paramIndex > 0 ? '&' : ''}${key}=${encodeURIComponent(paramValue)}`;
            paramIndex += 1;
        }
    }
    return paramString.length === 1 ? '' : paramString;
};
